import { Link2, FileText, ExternalLink } from "lucide-react";
import { RESOURCES } from "../data/conferenceData";

export default function Resources() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="resources-page">
      <h2
        style={{
          fontSize: "22px",
          fontWeight: 800,
          color: "var(--primary-dark)",
          marginBottom: "4px",
        }}
      >
        Links
      </h2>

      <div style={{ marginBottom: "24px", marginTop: "16px" }}>
        {/* Section header */}
        <div
          className="flex items-center"
          style={{ marginBottom: "10px", gap: "10px" }}
        >
          <div
            className="flex items-center justify-center"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              backgroundColor: "var(--primary)",
            }}
          >
            <Link2 size={20} color="white" strokeWidth={2} />
          </div>
          <p
            style={{
              fontSize: "16px",
              fontWeight: 800,
              color: "var(--primary-dark)",
            }}
          >
            Quick Access
          </p>
        </div>

        {RESOURCES.map((r) => (
          <a
            key={r.label}
            href={r.url}
            data-testid={`resource-${r.label}`}
            className="flex items-start"
            style={{
              backgroundColor: "var(--surface)",
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "8px",
              border: "1px solid var(--border)",
              gap: "10px",
            }}
          >
            <FileText
              size={18}
              color="var(--primary)"
              style={{ marginTop: "2px", flexShrink: 0 }}
            />
            <div className="flex-1">
              <p
                style={{
                  color: "var(--primary-dark)",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "19px",
                }}
              >
                {r.label}
              </p>
            </div>
            <ExternalLink
              size={16}
              color="var(--text-muted)"
              style={{ marginTop: "2px", flexShrink: 0 }}
            />
          </a>
        ))}
      </div>
    </div>
  );
}
